import { client } from './client';

export const getAllEntries = () => {
    return client.getEntries();
}